import { Modal } from '../../../../../core/components/templates/Modal';
import { ContentList } from '../../DailySchedule/ContentList';

interface IPlaylistModal {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
}

function PlaylistModal({ isOpen, onClose, title, subtitle }: IPlaylistModal) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      position='bottom'
      title={title}
      subtitle={subtitle}
      className={`mx-0 max-w-full rounded-b-none md:mx-0 md:mb-0`}
    >
      <div className='flex flex-col gap-lg'>
        <ContentList />
      </div>
    </Modal>
  );
}

export default PlaylistModal;
